import React from 'react';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
  id?: string;
  label?: string;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, id, label }) => {
  return (
    <label htmlFor={id} className="inline-flex items-center cursor-pointer">
      <span className="relative">
        <input
          id={id}
          type="checkbox"
          className="sr-only" // Hide the default checkbox
          checked={checked}
          onChange={onChange}
        />
        <div className={`block w-12 h-6 rounded-full transition-colors ${checked ? 'bg-brand-teal' : 'bg-gray-300 dark:bg-dark-tertiary'}`}></div>
        <div
          className={`dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-200 ease-in-out ${
            checked ? 'transform translate-x-6' : ''
          }`}
        ></div>
      </span>
      {label && <span className="ml-3 text-gray-900 dark:text-dark-text-primary font-medium">{label}</span>}
    </label>
  );
};
